"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var positions = {
  TL: "tl",
  TC: "tc",
  TR: "tr",
  RT: "rt",
  RC: "rc",
  RB: "rb",
  BL: "bl",
  BC: "bc",
  BR: "br",
  LT: "lt",
  LC: "lc",
  LB: "lb",
  CC: "cc",
  CT: "tc",
  CR: "rc",
  CB: "bc",
  CL: "lc"
};
var _default = exports["default"] = positions;
module.exports = exports.default;